import axios from 'axios';

const API_URL = '/api/signal-sources';

// 策略源列表(管理端)
export const getSources = async (params = {}) => {
  try {
    const response = await axios.get(API_URL, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '获取策略源列表失败' };
  }
};

// 创建策略源(响应含 sourceKeyPlain, 仅此一次完整显示)
export const createSource = async (data) => {
  try {
    const response = await axios.post(API_URL, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '创建策略源失败' };
  }
};

// 更新策略源(改名/改组/停启用)
export const updateSource = async (id, data) => {
  try {
    const response = await axios.post(`${API_URL}/${id}/update`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '更新策略源失败' };
  }
};

// 轮换推送凭证(旧key立即作废, 响应含新 sourceKeyPlain)
export const rotateSourceKey = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/${id}/rotate`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '轮换凭证失败' };
  }
};

// 删除策略源(有信号记录的不可删, 只能停用)
export const deleteSource = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: '删除策略源失败' };
  }
};

// 脱敏展示: 只显示前11位(sk- + 8hex)
export const maskSourceKey = (key) => {
  if (!key) return '—';
  return key.slice(0, 11) + '••••••••••••••••••••••••••••••••••';
};
